import type { CargoItem } from '@/types/cargoList.types';

export const mockCargoData: CargoItem[] = [
  {
    id: 39800,
    charterer: 'HPCL',
    lcStart: '2025-11-16T00:00:00',
    lcEnd: '2025-11-16T00:00:00',
    trade: 'AG/ECIndia',
    primaryBroker: null,
    reportedTime: '2025-11-03T08:41:15',
    cargoSize: 260000,
    brokerDidNotShare: false,
    maxAge: null,
    source: '',
    type: 'Spot Voyage',
    note: '',
    addressComm: 0.025,
    primaryComm: 0.01475,
    laytime: 120,
    privacyLevel: 'Public',
    isOnHold: 0,
    status: 'Confirmed',
    updatedTime: '2025-11-03T08:41:44.793',
    updatedBy: 'Jamie Ranger',
    typeId: 1,
    tradeId: 215,
    statusId: 9,
    certaintyId: 2,
    privacyLevelId: 1,
    chartererId: 791,
    rateAssessorId: null,
    primaryBrokerId: null,
    certainty: 'Reported',
    rateAssessor: null,
    isFixedDirect: false,
    isOnDailyReport: true,
    segment: 'VL',
  },
  {
    id: 39801,
    charterer: 'Bahri Oil Transportation',
    lcStart: '2025-11-18T00:00:00',
    lcEnd: '2025-11-23T00:00:00',
    trade: 'AG/Korea',
    primaryBroker: null,
    reportedTime: '2025-11-03T11:33:57.037',
    cargoSize: 145000,
    brokerDidNotShare: false,
    maxAge: null,
    source: '',
    type: 'Spot Voyage',
    note: '',
    addressComm: 0.025,
    primaryComm: 0.0125,
    laytime: 120,
    privacyLevel: 'Stealth',
    isOnHold: 0,
    status: 'Confirmed',
    updatedTime: '2025-11-03T11:33:57.037',
    updatedBy: 'Jamie Ranger',
    typeId: 1,
    tradeId: 3,
    statusId: 9,
    certaintyId: 2,
    privacyLevelId: 5,
    chartererId: 281,
    rateAssessorId: null,
    primaryBrokerId: null,
    certainty: 'Reported',
    rateAssessor: null,
    isFixedDirect: false,
    isOnDailyReport: false,
    segment: 'SM',
  },
  {
    id: 39803,
    charterer: 'Petrogal',
    lcStart: '2025-12-01T00:00:00',
    lcEnd: '2025-12-05T00:00:00',
    trade: 'Brazil/China',
    primaryBroker: null,
    reportedTime: '2025-11-03T16:20:15.97',
    cargoSize: 260000,
    brokerDidNotShare: false,
    maxAge: null,
    source: '',
    type: 'Spot Voyage',
    note: '',
    addressComm: 0.025,
    primaryComm: 0.0125,
    laytime: 120,
    privacyLevel: 'Stealth',
    isOnHold: 0,
    status: 'Confirmed',
    updatedTime: '2025-11-03T16:20:15.97',
    updatedBy: 'Jamie Ranger',
    typeId: 1,
    tradeId: 38,
    statusId: 9,
    certaintyId: 2,
    privacyLevelId: 5,
    chartererId: 310,
    rateAssessorId: null,
    primaryBrokerId: null,
    certainty: 'Reported',
    rateAssessor: null,
    isFixedDirect: false,
    isOnDailyReport: true,
    segment: 'VL',
  },
  {
    id: 39804,
    charterer: 'Shell Trading',
    lcStart: '2025-11-20T00:00:00',
    lcEnd: '2025-11-22T00:00:00',
    trade: 'WAF/Europe',
    primaryBroker: 'Maritime Brokers Ltd',
    reportedTime: '2025-11-04T09:15:30',
    cargoSize: 130000,
    brokerDidNotShare: false,
    maxAge: null,
    source: '',
    type: 'Programme',
    note: 'Priority cargo - handle with care',
    addressComm: 0.03,
    primaryComm: 0.02,
    laytime: 96,
    privacyLevel: 'Public',
    isOnHold: 0,
    status: 'Pending',
    updatedTime: '2025-11-04T09:15:30',
    updatedBy: 'Sarah Johnson',
    typeId: 2,
    tradeId: 45,
    statusId: 2,
    certaintyId: 1,
    privacyLevelId: 1,
    chartererId: 542,
    rateAssessorId: 12,
    primaryBrokerId: 89,
    certainty: 'Firm',
    rateAssessor: 'John Smith',
    isFixedDirect: true,
    isOnDailyReport: true,
    segment: 'SM',
  },
  {
    id: 39805,
    charterer: 'ExxonMobil',
    lcStart: '2025-11-25T00:00:00',
    lcEnd: '2025-11-30T00:00:00',
    trade: 'USG/Asia',
    primaryBroker: null,
    reportedTime: '2025-11-04T14:20:45',
    cargoSize: 280000,
    brokerDidNotShare: true,
    maxAge: 15,
    source: 'Market Intelligence',
    type: 'Spot Voyage',
    note: '',
    addressComm: 0.0275,
    primaryComm: 0.015,
    laytime: 144,
    privacyLevel: 'Private',
    isOnHold: 1,
    status: 'On Hold',
    updatedTime: '2025-11-04T14:20:45',
    updatedBy: 'Mike Chen',
    typeId: 1,
    tradeId: 67,
    statusId: 5,
    certaintyId: 3,
    privacyLevelId: 3,
    chartererId: 123,
    rateAssessorId: null,
    primaryBrokerId: null,
    certainty: 'Subject',
    rateAssessor: null,
    isFixedDirect: false,
    isOnDailyReport: false,
    segment: 'VL',
  },
];
